export enum VacancyReason {
  UnderRenovation = "Under Renovation",
  ForSale = "For Sale",
  BetweenTenants = "Between Tenants",
  Condemned = "Condemned",
  Other = "Other",
}
